// extracted by mini-css-extract-plugin
export default {"documents":"styles__documents___TYuFb","learn":"styles__learn___NG0l4","titleWrapper":"styles__titleWrapper___GxV6O","section":"styles__section___QseEi"};